export enum EaterType {
  VOLUNTEER = 'volunteer',
  ORGA = 'orga',
  OTHER = 'other',
}
